<template>
 <div>
     <el-upload
     action='aaa'
        :show-file-list="true"
        :file-list="playUrls"
        :http-request="uploadSectionFile"
        :on-remove="onRemove"
        :multiple="multiple"> <!--此处使用自定义上传实现http-request-->
        <el-button size="small" type="primary">点击上传</el-button>
        <!-- <div slot="tip" class="el-upload__tip">请等待进度条100%之后再提交表单</div> -->
    </el-upload>
    <!-- <el-progress v-show="showProgress" :text-inside="true" :stroke-width="18"
                 :percentage="uploadPercent"></el-progress> -->
 </div>
</template>

<script>
import { ossUploadBigFileNotLab } from '@/utils/action'
export default {
  props: {
    value: {
      type: [Array, Object, String],
      default: function () {
        return []
      }
    },
    resourceConfig: {
      type: String,
      default: ''
    },
    isPublic: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    isPathUrlAddTime: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      playUrls: [],
      showSectionFileName: true,
      sectionFileName: '',
      showProgress: true,
      uploadPercent: 0,
      currentValue: this.getValue(),
      isUpload: null
    }
  },
  computed: {
    resourceUrl () {
      return this.isPublic ? this.$publicResourcesUrl : this.$privateResourcesUrl
    }
  },
  watch: {
    value: {
      handler: function (val) {
        console.log('val--------------', val)
        if (val && JSON.stringify(val) !== '{}') {
          if (_.isString(val)) {
            val = {
              name: this.isPathUrlAddTime ? val.split('/')[1].split('-')[1] : val.split('/')[1],
              url: this.isPathUrlAddTime ? val.split('/')[0] + '/' + val.split('/')[1].split('-')[1] : val
            }
          }
          this.getImageList(val)
          this.currentValue = val
        }
      },
      immediate: true
    },
    playUrls (val) {
      console.log('val-----------list', val)
    },
    isUpload (val) {
      this.$emit('isUpload', val)
    }
  },
  methods: {
    getValue () {
      return this.multiple ? [] : {}
    },
    async uploadSectionFile (params) {
      console.log('params', params)
      this.isUpload = true
      let url = await this.$upload(this.resourceConfig, params.file, 'file', ossUploadBigFileNotLab, this.isPathUrlAddTime, this.isPublic)
      if (url) {
        this.isUpload = false
        let data = {
          url,
          name: params.file.name
        }
        if (this.multiple) {
          this.currentValue.push(data)
        } else {
          this.currentValue = data
        }
        this.playUrls.push(this.getImageUrl(data))
        this.$emit('input', this.currentValue)
      }
    },
    getImageUrl (data) {
      return {
        url: this.resourceUrl + data.url,
        name: data.name
      }
    },
    getImageList (arr) {
      if (!Array.isArray(arr)) {
        arr = [arr]
      }
      this.playUrls = arr.map(e => {
        return this.getImageUrl(e)
      })
    },
    onRemove (file, fileList) {
      if (this.multiple) {
        for (let i = 0; i < this.currentValue.length; i++) {
          if ((this.resourceUrl + this.currentValue[i].url) === file.url) {
            this.currentValue.splice(i, 1)
            break
          }
        }
        this.$emit('input', this.currentValue)
      } else {
        this.$emit('input', '')
      }
    }
  }
}
</script>

<style>

</style>
